function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import groupBy from 'ramda/src/groupBy';
import pathOr from 'ramda/src/pathOr';
import clone from 'ramda/src/clone';
import Immutable from 'seamless-immutable';
import { MetadataCodeTypeSelector, MetadataCodeTypeDictionarySelector, MetadataCodeTypeSansGlobalSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { thunkSelectors as ThunkSelectors } from 'invision-core/src/reducers/thunk.selector';
import { CurrentBusinessUnitSelector } from 'invision-core/src/components/session/businessunit.selectors';
import { RETRIEVE_USAGE_CAPS_PATH } from '../recoverableUiState/usage.caps.reducer';
import { mapUsageCaps, thresholdDisplayName } from './usage.caps.selectors.helper';
import { CurrentCappedAccountSelector, CurrentCappedServicesSelector } from './customer.convergent.biller.selectors';
import CustomerCareLocaleKeys from '../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import moment from 'moment';
import { getBoolOrDefault } from 'invision-core/src/components/helpers/bool.helper';
import { CurrentCustomerSelector } from './customer.selectors';
import { USAGE_CAPS_ELECTION_LEVEL } from '../../components/customer/servicesAndUsage/usageCaps/usage.caps.constants';
import { getFormattedServiceAttributeValue } from './services.list.selectors.helper';
import { SelectedCustomerSelector } from 'invision-core/src/components/customer/customer.selectors';
var EMPTY_ARRAY = [];
var EMPTY_STRING = '';
var UsageCapsRecoverableUIStateSelector = function UsageCapsRecoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.usageCaps;
};
export var IsUpdatingUsageCapSelector = createSelector([UsageCapsRecoverableUIStateSelector], function (recoverableUsageCaps) {
  return recoverableUsageCaps.isUpdatingData;
});
export var CurrentServiceIdSelector = function CurrentServiceIdSelector(state) {
  return state.router.currentParams.serviceId;
};
export var RetrievedUsageCaps = ThunkSelectors(UsageCapsRecoverableUIStateSelector, RETRIEVE_USAGE_CAPS_PATH);
export var AllServicesUsageCapsSelector = createImmutableSelector([RetrievedUsageCaps.dataSelector, MetadataCodeTypeDictionarySelector(CODES.UnitsOfMeasure)], function (retrieveUsageCaps, units) {
  if (retrieveUsageCaps) {
    //Using Object destructuring assignment to get nested property with a default value
    var _retrieveUsageCaps$Al = retrieveUsageCaps.AllServicesUsageCaps,
      AllServicesUsageCaps = _retrieveUsageCaps$Al === void 0 ? EMPTY_ARRAY : _retrieveUsageCaps$Al;
    var usageCaps = [];
    if (AllServicesUsageCaps.length) {
      usageCaps = AllServicesUsageCaps.map(function (item) {
        var usageCapItem = clone(item);
        if (item.ThresholdType && item.ThresholdType.Code) {
          var unit = Object.values(units).filter(function (unitItem) {
            return unitItem.Value === item.ThresholdType.Code.toString();
          })[0];
          usageCapItem.ThresholdType.Name = unit.Name;
        }
        return usageCapItem;
      });
    }
    return usageCaps;
  }
  return EMPTY_ARRAY;
});
export var UsageCapsElectionsSelector = createSelector([RetrievedUsageCaps.dataSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression), MetadataCodeTypeDictionarySelector(CODES.UnitsOfMeasure)], function (retrievedUsageCaps, serviceAttributes, regularExpressions, units) {
  if (retrievedUsageCaps) {
    //Using Object destructuring assignment to get nested property with a default value
    var _retrievedUsageCaps$U = retrievedUsageCaps.UsageCapElections,
      UsageCapElections = _retrievedUsageCaps$U === void 0 ? EMPTY_ARRAY : _retrievedUsageCaps$U;
    if (UsageCapElections.length) {
      return UsageCapElections.map(function (usageCapElection) {
        var usageCap = clone(usageCapElection);
        if (usageCap.ServiceIdentifier) {
          var _usageCap$ServiceIden = usageCap.ServiceIdentifier,
            Value = _usageCap$ServiceIden.Value,
            ServiceAttributeId = _usageCap$ServiceIden.ServiceAttributeId;
          usageCap.ServiceIdentifier.FormattedValue = getFormattedServiceAttributeValue(ServiceAttributeId, Value, serviceAttributes, regularExpressions);
        }
        if (usageCapElection.ThresholdType && usageCapElection.ThresholdType.Code) {
          var unit = Object.values(units).filter(function (unitItem) {
            return unitItem.Value === usageCapElection.ThresholdType.Code.toString();
          })[0];
          usageCap.ThresholdType.Name = unit.Name;
        }
        return usageCap;
      });
    }
  }
  return Immutable(EMPTY_ARRAY);
});
export var UsageCapsEnabledSelector = createSelector([UsageCapsElectionsSelector], function (usageCapsElections) {
  if (usageCapsElections) {
    return usageCapsElections.filter(function (usageCapsElection) {
      return usageCapsElection.UsageCapEnabled === true;
    });
  }
});
export var MappedAllUsageNotificationEnabledSelector = createSelector([UsageCapsElectionsSelector], function (usageCapsElections) {
  return (usageCapsElections || EMPTY_ARRAY).filter(function (usageCapsElection) {
    return usageCapsElection.UsageNotificationEnabled && !usageCapsElection.UsageCapEnabled;
  });
});
export var MappedUsageCapsSelector = createSelector([UsageCapsEnabledSelector, CurrentCustomerSelector, CurrentServiceIdSelector], function (usageCapsEnabled, currentCustomer, currentServiceId) {
  if (usageCapsEnabled && usageCapsEnabled.length && currentCustomer) {
    var findUsageCapsInstances = function findUsageCapsInstances(usageCap) {
      if (!usageCap.PricingPlanId) {
        if (currentServiceId) {
          return usageCap.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL && usageCap.ServiceIdentifier.Value === currentServiceId;
        }
        return usageCap.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL;
      }
      return false;
    };
    var mappedUsageCaps = mapUsageCaps(usageCapsEnabled.filter(findUsageCapsInstances), currentCustomer.SubscriberCurrency);
    //Group all caps by Service
    var groupedUsageCapsByService = groupBy(pathOr(undefined, ['ServiceIdentifier', 'Value']))(mappedUsageCaps);
    return Immutable(groupedUsageCapsByService);
  }
  return Immutable(EMPTY_ARRAY);
});
export var MappedPlanUsageCapsSelector = createSelector([UsageCapsEnabledSelector, CurrentCustomerSelector, CurrentServiceIdSelector], function (usageCapsEnabled, currentCustomer, currentServiceId) {
  if (usageCapsEnabled && usageCapsEnabled.length && currentCustomer) {
    var findUsageCapsInstances = function findUsageCapsInstances(usageCap) {
      if (usageCap.PricingPlanId) {
        if (currentServiceId) {
          return usageCap.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL && usageCap.ServiceIdentifier.Value === currentServiceId;
        }
        return usageCap.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL;
      }
      return false;
    };
    var mappedUsageCaps = mapUsageCaps(usageCapsEnabled.filter(findUsageCapsInstances), currentCustomer.SubscriberCurrency);
    //Group all caps by Service
    var groupedUsageCapsByService = groupBy(pathOr(undefined, ['ServiceIdentifier', 'Value']))(mappedUsageCaps);
    return Immutable(groupedUsageCapsByService);
  }
  return Immutable(EMPTY_ARRAY);
});
export var MappedUsageNotificationEnabledSelector = createSelector([MappedAllUsageNotificationEnabledSelector, CurrentCustomerSelector, CurrentServiceIdSelector], function (mappedAllUsageNotificationEnabled, currentCustomer, currentServiceId) {
  if (mappedAllUsageNotificationEnabled && mappedAllUsageNotificationEnabled.length && currentCustomer) {
    var findUsageCapsInstances = function findUsageCapsInstances(usageCap) {
      if (currentServiceId) {
        return usageCap.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL && usageCap.ServiceIdentifier.Value === currentServiceId;
      }
      return usageCap.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.SERVICE_LEVEL;
    };
    var mappedUsageCaps = mapUsageCaps(mappedAllUsageNotificationEnabled.filter(findUsageCapsInstances), currentCustomer.SubscriberCurrency);
    //Group all caps by Service
    var groupedUsageCapsByService = groupBy(pathOr(undefined, ['ServiceIdentifier', 'Value']))(mappedUsageCaps);
    return Immutable(groupedUsageCapsByService);
  }
  return Immutable(EMPTY_ARRAY);
});
export var MappedAllServicesUsageCapsSelector = createSelector([AllServicesUsageCapsSelector, UsageCapsElectionsSelector, CurrentCustomerSelector], function (allServicesUsageCaps, usageCapElections, currentCustomer) {
  if (allServicesUsageCaps && allServicesUsageCaps.length && currentCustomer) {
    var mappedUsageCaps = mapUsageCaps(allServicesUsageCaps, currentCustomer.SubscriberCurrency, true);
    var determineAllServicesUsageCapsValues = function determineAllServicesUsageCapsValues(allServicesUsageCap) {
      var _currentUsageCapsInst, _currentUsageCapsInst2, _currentUsageCapsInst3, _currentUsageCapsInst4;
      var findUsageCapsInstances = function findUsageCapsInstances(usageCap) {
        return usageCap.Id === allServicesUsageCap.Id && usageCap.ElectionLevel === USAGE_CAPS_ELECTION_LEVEL.CUSTOMER_LEVEL;
      };
      var currentUsageCapsInstances = usageCapElections.filter(findUsageCapsInstances);
      var mostUsedThreshold = currentUsageCapsInstances.length && allServicesUsageCap.Thresholds && allServicesUsageCap.Thresholds.length ? determineMostUsedThreshold(allServicesUsageCap, currentUsageCapsInstances, currentCustomer.SubscriberCurrency) : {
        electedThreshold: allServicesUsageCap.Thresholds && allServicesUsageCap.Thresholds[0] || null
      };
      var elected = currentUsageCapsInstances.length > 0 && currentUsageCapsInstances.every(function (usageCap) {
        return !!usageCap.Elected;
      });
      var usageCapEnabled = currentUsageCapsInstances.length > 0 && currentUsageCapsInstances.every(function (usageCap) {
        return !!usageCap.UsageCapEnabled;
      });
      var isEnabled = elected && mostUsedThreshold.enabled;
      return Immutable(allServicesUsageCap.merge({
        BreachedResetDate: currentUsageCapsInstances.length && ((_currentUsageCapsInst = currentUsageCapsInstances[0]) === null || _currentUsageCapsInst === void 0 ? void 0 : _currentUsageCapsInst.BreachedResetDate),
        Elected: elected && isEnabled,
        ElectedThreshold: mostUsedThreshold.electedThreshold,
        enabled: isEnabled,
        PricingPlanId: currentUsageCapsInstances.length && ((_currentUsageCapsInst2 = currentUsageCapsInstances[0]) === null || _currentUsageCapsInst2 === void 0 ? void 0 : _currentUsageCapsInst2.PricingPlanId),
        RemainingCapAmount: currentUsageCapsInstances.length && ((_currentUsageCapsInst3 = currentUsageCapsInstances[0]) === null || _currentUsageCapsInst3 === void 0 ? void 0 : _currentUsageCapsInst3.RemainingCapAmount),
        selected: mostUsedThreshold.electedThreshold ? 'selected' : undefined,
        UsageCapBehavior: currentUsageCapsInstances.length && ((_currentUsageCapsInst4 = currentUsageCapsInstances[0]) === null || _currentUsageCapsInst4 === void 0 ? void 0 : _currentUsageCapsInst4.UsageCapBehavior),
        UsageCapEnabled: usageCapEnabled,
        UsageCapUsageNotification: currentUsageCapsInstances.length && currentUsageCapsInstances[0].UsageCapUsageNotification,
        UsageNotificationEnabled: currentUsageCapsInstances.length && currentUsageCapsInstances[0].UsageNotificationEnabled
      }));
    };
    return mappedUsageCaps.map(determineAllServicesUsageCapsValues);
  }
  return Immutable(EMPTY_ARRAY);
});
export var AccountLevelUsageCaps = createSelector([MappedAllServicesUsageCapsSelector], function (allServicesUsageCaps) {
  return (allServicesUsageCaps || EMPTY_ARRAY).filter(function (item) {
    return item.UsageCapEnabled && !item.PricingPlanId;
  });
});
export var AccountLevelPlanUsageCaps = createSelector([MappedAllServicesUsageCapsSelector], function (allServicesUsageCaps) {
  return (allServicesUsageCaps || EMPTY_ARRAY).filter(function (item) {
    return item.UsageCapEnabled && item.PricingPlanId;
  });
});
export var AccountLevelUsageNotification = createSelector([MappedAllServicesUsageCapsSelector, UsageCapsElectionsSelector], function (allServicesUsageCaps) {
  return (allServicesUsageCaps || EMPTY_ARRAY).filter(function (item) {
    return item.UsageNotificationEnabled && !item.UsageCapEnabled;
  });
});
export var IsUsageCapsEnabledSelector = createSelector([MetadataCodeTypeSansGlobalSelector(CODES.SubscriberSearchConfig), MappedAllServicesUsageCapsSelector], function (usageCapSettings, MappedAllServicesUsage) {
  //Determines if any of the account level usage caps have been activated.
  var electedServices = MappedAllServicesUsage.filter(function (service) {
    return service.Elected === true;
  });
  //Determines if the flag on enable customer level usage caps is set to true
  var prop = usageCapSettings.length ? usageCapSettings[0].AdditionalProperties.find(function (prop) {
    return prop.Key === 'enable_customer_level_usage_caps';
  }) : {};
  return prop.Value === 'False' && !electedServices.length ? false : true;
});
export var IsUsageCapsElectionDisabledSelector = createSelector([MetadataCodeTypeSansGlobalSelector(CODES.SubscriberSearchConfig), MappedAllServicesUsageCapsSelector], function (usageCapSettings, MappedAllServicesUsage) {
  //Selector for scenario that Usage Cap Rules are turned off and user has Elected at least one Account level cap
  var electedServices = MappedAllServicesUsage.filter(function (service) {
    return service.Elected === true;
  });
  var prop = usageCapSettings.length ? usageCapSettings[0].AdditionalProperties.find(function (prop) {
    return prop.Key === 'enable_customer_level_usage_caps';
  }) : {};
  return electedServices.length && prop.Value === 'False' ? true : false;
});
export var BreachedUsageCapsMessageSelector = createSelector([CurrentCappedServicesSelector], function (_ref) {
  var serviceIdentifiers = _ref.ServiceIdentifiers,
    capResetDate = _ref.CapResetDate;
  if (serviceIdentifiers && capResetDate) {
    var utcMoment = moment.utc();
    var capResetDateUTC = moment.utc(capResetDate);
    var utcDiffInDays = capResetDateUTC.diff(utcMoment, 'days');
    var resetDate = '';
    if (utcDiffInDays >= 1) {
      resetDate = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.RESET_DATE, {
        days: utcDiffInDays
      });
    } else {
      resetDate = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.RESET_DATE_TODAY);
    }
    var resetDateMessage = "".concat(i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.RESET_MESSAGE), " ").concat(resetDate);
    if (serviceIdentifiers.length > 5) {
      return "".concat(i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.CAPPED_SERVICES_SEVERAL), " ").concat(resetDateMessage);
    } else {
      var messageSeparator = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CAP_INDICATOR.MESSAGE_SEPARATOR);
      var serviceList = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.CAPPED_SERVICES_LIST, {
        cappedServicesList: formatServiceList(serviceIdentifiers, messageSeparator)
      });
      return "".concat(serviceList, " ").concat(resetDateMessage);
    }
  }
  return EMPTY_STRING;
});
export var BreachedAccountLevelUsageCapsMessageSelector = createSelector(CurrentCappedAccountSelector, function (BreachedRules) {
  var messageSeparator = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.USAGE_CAP_INDICATOR.MESSAGE_SEPARATOR);
  if (!BreachedRules || !BreachedRules.length) {
    return EMPTY_STRING;
  }
  return i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.CAPPED_ACCOUNT, {
    breachedCaps: formatAccountLevelUsageCapsList(BreachedRules, messageSeparator),
    countCapsBreached: BreachedRules.length
  });
});
var formatServiceList = function formatServiceList(serviceIdentifiers, messageSeparator) {
  var numberOfServices = serviceIdentifiers.length;
  if (numberOfServices) {
    var commaSeparatedServices = function commaSeparatedServices(formattedString, serviceId, index) {
      if (index === numberOfServices - 1 && numberOfServices > 1) {
        return "".concat(formattedString).concat(messageSeparator, " ").concat(serviceId.Value);
      }
      var separator = EMPTY_STRING;
      if (numberOfServices > 1) {
        separator = index === numberOfServices - 2 ? ' ' : ',';
      }
      return "".concat(formattedString, " ").concat(serviceId.Value).concat(separator);
    };
    return serviceIdentifiers.reduce(commaSeparatedServices, EMPTY_STRING);
  }
};
var formatAccountLevelUsageCapsList = function formatAccountLevelUsageCapsList(serviceIdentifiers, messageSeparator) {
  var numberOfServices = serviceIdentifiers.length;
  var todayMessage = i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.RESET_DATE_TODAY_ACCOUNT);
  var formattedIdentifiers = serviceIdentifiers.map(function (service) {
    var utcMoment = moment.utc();
    var capResetDateUTC = moment.utc(service['BreachedResetDate']);
    var utcDiffInDays = capResetDateUTC.diff(utcMoment, 'days');
    var resetDate = utcDiffInDays >= 1 ? i18n.translate(CustomerCareLocaleKeys.USAGE_CAPS.BREACHED_CAPS.RESET_DATE_ACCOUNT, {
      days: utcDiffInDays
    }) : todayMessage;
    return "".concat(service.Name, " ").concat(resetDate);
  });
  return [formattedIdentifiers.slice(0, -1).join(', '),
  // all elements but last
  formattedIdentifiers.slice(-1)[0] // only last element
  ].join(numberOfServices < 2 ? ' ' : " ".concat(messageSeparator, " "));
};
function findAdditionalProperty(additionalProperties, targetProperty) {
  var findPropertyByKey = function findPropertyByKey(property) {
    return property.Key === targetProperty;
  };
  return additionalProperties.find(findPropertyByKey);
}
var determineMostUsedThreshold = function determineMostUsedThreshold(allServicesThresholds, usageCapsInstances, SubscriberCurrency) {
  var mostUsedThreshold = {};
  var maxCount = 0;
  var mostUsedMap = {};
  var getMaxOcurringThreshold = function getMaxOcurringThreshold(cap) {
    var calculatedElectedThreshold = cap.ElectedThreshold || cap.Thresholds[0];
    mostUsedMap[calculatedElectedThreshold.Id] ? mostUsedMap[calculatedElectedThreshold.Id]++ : mostUsedMap[calculatedElectedThreshold.Id] = 1;
    if (mostUsedMap[calculatedElectedThreshold.Id] > maxCount) {
      maxCount = mostUsedMap[calculatedElectedThreshold.Id];
      mostUsedThreshold = {
        electedThreshold: _objectSpread(_objectSpread({}, calculatedElectedThreshold), {}, {
          DisplayName: thresholdDisplayName(calculatedElectedThreshold, cap.ThresholdType, SubscriberCurrency)
        })
      };
    }
  };
  usageCapsInstances.forEach(getMaxOcurringThreshold);
  //Threshold Dropdown will be enabled only when all of it's ocurrences have the same value selected
  mostUsedThreshold && (mostUsedThreshold.enabled = Object.keys(mostUsedMap).length === 1);
  return mostUsedThreshold;
};
export var NoUsageCapsMessageSelectors = createSelector([MetadataCodeTypeSelector(CODES.UsageCapMenuTitle)], function (usageCapMenuTitleCodes) {
  var message = null;
  if (usageCapMenuTitleCodes && usageCapMenuTitleCodes.length) {
    var currentBusinessUnitCodeMessage = undefined;
    var globalMessage = undefined;
    var _iterator = _createForOfIteratorHelper(usageCapMenuTitleCodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var code = _step.value;
        var isEnabled = getBoolOrDefault(findAdditionalProperty(code.AdditionalProperties, 'enabled').Value, false);
        message = findAdditionalProperty(code.AdditionalProperties, 'no_usage_caps_message');
        if (isEnabled && !code.Global && message && message.Value) {
          currentBusinessUnitCodeMessage = message.Value;
          break;
        } else if (isEnabled) {
          globalMessage = message.Value;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return currentBusinessUnitCodeMessage || globalMessage;
  }
});
export var SelectedAccountLevelSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer ? selectedCustomer.bulkItems.isAccountLevelSelected : false;
});